import React from "react";
import SectionTitle from "../components/SectionTitle";
import { projectTiles } from "../data/projects";

export default function ProjectsSection({ onOpenDialog }) {
  return (
    <div className="section container col-center pb-24 sm:pb-16 lg:pb-20">
      <SectionTitle title="Projects" className="mt-10" />
      <div className=" grid w-full grid-cols-1 gap-y-14 px-10 pt-20 md:grid-cols-2 lg:gap-x-16 lg:gap-y-10 lg:grid-cols-3 lg:px-20">
        {projectTiles.map((tile) => (
          <div key={tile.id} className="cp-tile-shell">
            <span className={`cp-tile-badge ${tile.badgeClass}`}>
              {tile.badgeText}
            </span>
            <button
              type="button"
              onClick={() => onOpenDialog(tile.id)}
              className="cp-tile-button"
            >
              <tile.Logo className={tile.logoClassName} />
              <h3>{tile.title}</h3>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
